import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translate, translate } from 'react-i18nify';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import WarningIcon from '@material-ui/icons/Warning';
import GoodIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';

import moment from 'moment';

import CudaTableTitle from './../CudaTableTitle';
import TableLoading from './../table/TableLoading';
import Paper from '../CudaPaper';

class SubscriptionModule extends Component {
  componentDidMount() {
    if (this.props.initData) {
      this.props.initData();
    }
  }

  render() {
    const {
      classes,
      loading,
      mspSubStats,
      elevation,
      displayCount = true,
    } = this.props;

    return (
      <Paper className={classes.paper} elevation={elevation}>
        <div className={classes.headerSection}>
          <div className={classes.title}>
            <Translate value="shared.subscriptions" />
          </div>
        </div>
        <Table className={classes.subTable}>
          <TableHead>
            <TableRow className={classes.headerRow}>
              <TableCell className={classes.cell}>
                <CudaTableTitle value="shared.type" />
              </TableCell>
              {displayCount && (
                <TableCell className={classes.cell}>
                  <CudaTableTitle value="shared.licenses" />
                </TableCell>
              )}
              <TableCell className={classes.cell}>
                <CudaTableTitle value="shared.expires" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!loading && mspSubStats['dns'] && (
              <TableRow className={classes.tableRowContent}>
                <TableCell className={classes.cell}>
                  {translate('components.dashboard.skus.dns')}
                </TableCell>
                {displayCount && (
                  <TableCell className={classes.cell}>
                    {mspSubStats['dns'].capacity.toLocaleString()}
                  </TableCell>
                )}
                <TableCell className={classes.cell}>
                  <span
                    className={classNames(classes.subStatus, {
                      [classes.error]:
                        mspSubStats['dns']['state'] === 'expired',
                    })}
                  >
                    {
                      {
                        warning: (
                          <WarningIcon className={classes.warningIcon} />
                        ),
                        expired: <ErrorIcon className={classes.expiredIcon} />,
                        good: <GoodIcon className={classes.goodIcon} />,
                      }[mspSubStats['dns']['state']]
                    }
                    {moment(mspSubStats['dns'].expiredate).format('MM/DD/YY')}
                  </span>
                </TableCell>
              </TableRow>
            )}
            {!loading && mspSubStats['wca'] && (
              <TableRow className={classes.tableRowContent}>
                <TableCell className={classes.cell}>
                  {translate('shared.advancedFiltering')}
                </TableCell>
                {displayCount && (
                  <TableCell className={classes.cell}>
                    {mspSubStats['wca'].capacity.toLocaleString()}
                  </TableCell>
                )}
                <TableCell className={classes.cell}>
                  <span
                    className={classNames(classes.subStatus, {
                      [classes.error]:
                        mspSubStats['wca']['state'] === 'expired',
                    })}
                  >
                    {
                      {
                        warning: (
                          <WarningIcon className={classes.warningIcon} />
                        ),
                        expired: <ErrorIcon className={classes.expiredIcon} />,
                        good: <GoodIcon className={classes.goodIcon} />,
                      }[mspSubStats['wca']['state']]
                    }
                    {moment(mspSubStats['wca'].expiredate).format('MM/DD/YY')}
                  </span>
                </TableCell>
              </TableRow>
            )}
            {!loading && !mspSubStats['atp'] && !mspSubStats['wca'] && (
              <TableRow className={classes.tableRowContent}>
                <TableCell className={classes.cell}>
                  {translate('shared.advancedFiltering')}
                </TableCell>
                <TableCell className={classes.cell}>
                  {translate('shared.notPurchased')}
                </TableCell>
                <TableCell className={classes.cell}>
                  <a
                    href={'https://www.barracuda.com'}
                    className={classes.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {translate('shared.learnMore')}
                  </a>
                </TableCell>
              </TableRow>
            )}
            {loading && <TableLoading colSpan={3} />}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

const styles = theme => ({
  cell: {
    padding: '4px 14px',
    '&:last-child': {
      paddingRight: '14px',
    },
  },
  paper: {
    border: '1px solid #DDDDDD',
  },
  error: {
    color: theme.statusColors.failure,
  },
  subStatus: {
    display: 'flex',
    alignItems: 'center',
    '& > svg': {
      marginRight: '8px',
    },
  },
  subTable: {
    '& tr': {
      height: '32px',
    },
  },
  headerSection: {
    padding: '20px 20px 5px 14px',
  },
  warningIcon: {
    fill: theme.statusColors.warning,
  },
  expiredIcon: {
    fill: theme.statusColors.failure,
  },
  goodIcon: {
    fill: theme.statusColors.success,
  },
  title: {
    fontSize: '24px',
    fontWeight: 300,
  },
  link: {
    color: '#0088CF',
    textDecoration: 'none',
  },
  headerRow: {
    '& th': {
      borderTop: '1px solid rgba(224, 224, 224, 1)',
    },
  },
  tableRowContent: {
    '& td': {
      border: 'none',
    },
  },
});

SubscriptionModule.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  mspSubStats: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      capacity: PropTypes.number,
      expiredate: PropTypes.string,
    })
  ).isRequired,
  elevation: PropTypes.number,
};

SubscriptionModule.defaultProps = {
  elevation: 0,
};

export default withStyles(styles)(SubscriptionModule);
